import React, { useEffect } from 'react'
import { Link } from 'gatsby'
import { useIntl, FormattedMessage } from 'react-intl'
import { connectSearchBox } from 'react-instantsearch-dom'

export default connectSearchBox(
  ({ currentRefinement, refine, isSearchStalled, recommendedSearchTerms, query, ...rest }) => {
    const { locale } = useIntl()
    const key = locale.toLowerCase()

    // Update refinement when query parameters change
    useEffect(() => {
      refine(query)
    }, [query]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
      <>
        <div className='flex items-center h-12 text-black mb-4 relative'>
          <div className='flex all-center h-full border-l border-y border-gray rounded-l pl-4 py-2 text-sm'>
            <em className='fas fa-search' />
          </div>
          <input
            placeholder={rest.placeholder}
            aria-label={rest.placeholder}
            type='text'
            value={currentRefinement}
            onChange={event => refine(event.target.value)}
            {...rest}
            className='flex flex-grow h-full px-4 py-2 border-y border-gray rounded-none text-sm text-black whitespace-no-wrap overflow-hidden'
          />
          {isSearchStalled && (
            <span className='mt-6 top-0 absolute mr-40 ais-SearchBox-loadingIndicator'>
              <svg
                width='18'
                height='18'
                viewBox='0 0 38 38'
                xmlns='http://www.w3.org/2000/svg'
                stroke='#444'
                className='ais-SearchBox-loadingIcon'
              >
                <g fill='none' fillRule='evenodd'>
                  <g transform='translate(1 1)' strokeWidth='2'>
                    <circle strokeOpacity='.5' cx='18' cy='18' r='18' />
                    <path d='M36 18c0-9.94-8.06-18-18-18' transform='rotate(76.0918 18 18)'>
                      <animateTransform
                        attributeName='transform'
                        type='rotate'
                        from='0 18 18'
                        to='360 18 18'
                        dur='1s'
                        repeatCount='indefinite'
                      />
                    </path>
                  </g>
                </g>
              </svg>
            </span>
          )}
          {currentRefinement && !isSearchStalled && (
            <button
              onClick={() => refine('')}
              type='reset'
              title='Clear the search query.'
              className='mt-6 top-0 absolute mr-40 ais-SearchBox-reset'
            >
              <svg
                className='ais-SearchBox-resetIcon'
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 20 20'
                width='10'
                height='10'
              >
                <path d='M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z' />
              </svg>
            </button>
          )}
          <submit className='flex all-center h-full px-8 py-4 bg-green-dark hover:bg-white border border-green rounded-r font-nunito font-extrabold text-white hover:text-green whitespace-no-wrap cursor-pointer'>
            Search <em className='ml-2 fas fa-caret-right' />
          </submit>
        </div>
        <div className='mb-2'>
          <span className='extended mr-2 text-gray-dark'>
            <FormattedMessage id='recommended-search-terms' />:
          </span>
          {recommendedSearchTerms.map(({ name }, index) => (
            <Link key={index} to={`?q=${name}`} className='tag'>
              {name}
            </Link>
          ))}
        </div>
        {isSearchStalled && (
          <div className='headline-2 my-8'>
            <FormattedMessage id='loading' />
          </div>
        )}
      </>
    )
  }
)
